import { render, staticRenderFns } from "./MasterDataTabBar.vue?vue&type=template&id=45009ed8"
import script from "./MasterDataTabBar.vue?vue&type=script&lang=js"
export * from "./MasterDataTabBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports